import Cookies from 'js-cookie';

export default defineNuxtPlugin(async () => {
  const token = process.client ? Cookies.get('token') : '';

  // The login flow stores only the user id in the `user` cookie, so the
  // server-verified JWT is the reliable condition here. Non-admin users are
  // rejected by the Socket.IO authentication middleware.
  if (process.client && token) {
    // Public visitors never use real-time admin events. Loading Socket.IO only
    // after a signed-in visitor is detected keeps it out of the first bundle.
    const { io } = await import('socket.io-client');
    const config = useRuntimeConfig();
    const socket = io('https://api.inanctur.com.tr', {
      withCredentials: true, // Required for CORS with credentials
      transports: ['websocket'], // Use websocket transport
      auth: {
        token,
      },
    }); // Sunucu URL'sini kullan 
    return {
      provide: {
        socket,
      },
    };
  }else{
    return {
      provide: {
        socket: null,
      },
    };
  }
});
